import { create } from "zustand"

interface SearchLocation {
  latitude: number
  longitude: number
  location: string
  locationId: number
  userSelectedService: number
  radius: number
  liveLocation: boolean
}

interface SearchLocationStore {
  searchLocation: SearchLocation
  updateSearchLocation: (data: Partial<SearchLocation>) => void
  clearSearchLocation: () => void
}

export const useSearchLocation = create<SearchLocationStore>((set) => ({
  searchLocation: {
    latitude: 0,
    longitude: 0,
    userSelectedService:0,
    location: "",
    locationId: 0,
    radius: 5,
    liveLocation: false,
  },

  updateSearchLocation: (data) =>
    set((state) => ({
      searchLocation: { ...state.searchLocation, ...data },
    })),

  clearSearchLocation: () =>
    set({
      searchLocation: {
        latitude: 0,
        longitude: 0,
        userSelectedService:0,
        location: "",
        locationId: 0,
        radius: 5,
        liveLocation: false,
      },
    }),
}))
